'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-danger:0 */


/**
 * A message with the stucture:
 * Image, title, message, action.
 * That can be displayed modally or fullscreen.
 */
var ContentMessage = function (_React$Component) {
	_inherits(ContentMessage, _React$Component);

	function ContentMessage() {
		_classCallCheck(this, ContentMessage);

		return _possibleConstructorReturn(this, (ContentMessage.__proto__ || Object.getPrototypeOf(ContentMessage)).apply(this, arguments));
	}

	_createClass(ContentMessage, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    className = _props.className,
			    title = _props.title,
			    summary = _props.summary,
			    detail = _props.detail,
			    onClose = _props.onClose,
			    onAction = _props.onAction,
			    actionLabel = _props.actionLabel,
			    actionClass = _props.actionClass,
			    cancelLabel = _props.cancelLabel,
			    imgClass = _props.imgClass,
			    confirm = _props.confirm,
			    onSecondaryAction = _props.onSecondaryAction,
			    secondaryActionLabel = _props.secondaryActionLabel,
			    secondaryActionGlyph = _props.secondaryActionGlyph,
			    secondaryActionClass = _props.secondaryActionClass;

			var buttonClass = confirm ? 'btn-lg compact ' + (actionClass || 'btn-default') : 'btn-primary';
			var secondaryButtonClass = secondaryActionLabel !== undefined ? 'btn-lg compact btn-default ' + secondaryActionClass : secondaryActionClass;

			var content = _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)(className, 'contentmessage') },
				_react2.default.createElement(
					'div',
					{ className: 'message' },
					onClose && _react2.default.createElement('button', { className: 'close gg icon-GG-cross', onClick: onClose }),
					_react2.default.createElement(
						'div',
						{ className: 'contenticon' },
						imgClass === 'spinner' && _react2.default.createElement(_Spinner2.default, { bsSize: 'large' }),
						imgClass !== 'spinner' && _react2.default.createElement('div', { className: imgClass, 'aria-hidden': 'true' })
					),
					title && _react2.default.createElement(
						'div',
						{ className: 'title' },
						title
					),
					summary && _react2.default.createElement(
						'div',
						{ className: 'summary' },
						summary
					),
					detail && _react2.default.createElement(
						'div',
						{ className: 'detail' },
						detail
					),
					(onAction || onClose && confirm && cancelLabel) && _react2.default.createElement(
						'div',
						{ className: 'actionbar' },
						onAction && _react2.default.createElement(
							'button',
							{
								id: 'content-message-action',
								className: (0, _classnames2.default)('btn', buttonClass),
								onClick: onAction,
								ref: function ref(el) {
									_this2.actionButton = el;
								}
							},
							this.props.actionGlyph && _react2.default.createElement('span', { className: this.props.actionGlyph }),
							actionLabel
						),
						onSecondaryAction && secondaryActionLabel && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'button-divider' },
								'or'
							),
							_react2.default.createElement(
								'button',
								{
									id: 'content-message-secondary-action',
									className: (0, _classnames2.default)('btn', secondaryButtonClass),
									onClick: onSecondaryAction
								},
								secondaryActionGlyph && _react2.default.createElement('span', { className: secondaryActionGlyph }),
								secondaryActionLabel
							)
						),
						onClose && cancelLabel && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'button',
								{
									id: 'content-message-close',
									className: 'modalclose btn btn-lg btn-link',
									onClick: onClose,
									ref: function ref(el) {
										_this2.closeButton = el;
									}
								},
								cancelLabel
							)
						)
					)
				)
			);
			var modalContent = _react2.default.createElement(
				_reactBootstrap.Modal,
				{ backdrop: true, animation: false, show: true, onHide: onClose },
				content
			);

			return this.props.inlineContent ? content : modalContent;
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.actionButton) {
				this.actionButton.focus();
			} else if (this.closeButton) {
				this.closeButton.focus();
			}
		}
	}]);

	return ContentMessage;
}(_react2.default.Component);

ContentMessage.propTypes = {
	/**
  * Applies the class name to the container.  The following classes have
  * special meaning:
  *
  * `lg`: Renders a larger component container
  * `success`: Renders the icon using a success color.
  * `warning`: Renders the icon using a warning color.
  * `error`: Renders the icon using a error color.
  * `disabled`: Renders the icon using a disabled color.
  */
	className: _propTypes2.default.string,

	/**
  * Determines if the content should be displayed in a modal or inline element
  */
	inlineContent: _propTypes2.default.bool,

	/**
  * Callback method for when the dialog is closed or cancelled.
  */
	onClose: _propTypes2.default.func,

	/**
  * Callback method or when the component's primary action is clicked.
  */
	onAction: _propTypes2.default.func,

	/**
  * The label to apply to the primary action.
  */
	actionLabel: _propTypes2.default.string,

	/**
  * The class to apply to the button.
  */
	actionClass: _propTypes2.default.string,

	/**
  * The glyph class to apply to the button.
  */
	actionGlyph: _propTypes2.default.string,
	/**
  * Callback method for a secondary button
  */
	onSecondaryAction: _propTypes2.default.func,
	/**
  * The label to apply to a secondary action
  */
	secondaryActionLabel: _propTypes2.default.string,
	/**
  * The class to apply to the button.
  */
	secondaryActionClass: _propTypes2.default.string,
	/**
 * The glyph class to apply to the secondary button.
  */
	secondaryActionGlyph: _propTypes2.default.string,

	/**
  * The label to apply to the cancel action (if `confirm` is true).
  */
	cancelLabel: _propTypes2.default.string,

	/**
  * Class name to apply to the main component image.
  */
	imgClass: _propTypes2.default.string,

	/**
  * The title of the component.
  */
	title: _propTypes2.default.node,

	/**
  * Message summary.  Not used when `confirm` is true.
  */
	summary: _propTypes2.default.node,

	/**
  * The message detail.
  */
	detail: _propTypes2.default.node,

	/**
  * Enables modal dialog.
  */
	modal: _propTypes2.default.bool,

	/**
  * Enables cancel button when `cancelLabel` is defined.
  */
	confirm: _propTypes2.default.bool
};

ContentMessage.defaultProps = {
	className: '',
	secondaryActionClass: '',
	imgClass: 'gg icon-GG-cross-circle '
};

var _default = ContentMessage;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ContentMessage, 'ContentMessage', 'src/components/ContentMessage.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ContentMessage.jsx');
}();

;